import React from 'react';
import { getFormatedDate, getFormatedTime } from 'modules/emergencies/utils/dateUtils';
import { SETTINGS } from 'modules/emergencies/constants';
import RegularText from 'modules/emergencies/components/ui/texts/RegularText';
import BlackText from 'modules/emergencies/components/ui/texts/BlackText';
import BodyColumn from 'modules/emergencies/components/ui/columns/bodyColumn';
import InnerColumn from 'modules/emergencies/components/ui/columns/innerColumn';
import Row from 'modules/emergencies/components/ui/rows/row';

import styled from 'styled-components';

const CustomBlackText = styled(BlackText)`
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CustomRegularText = styled(RegularText)`
  font-weight: 700;
`;

export const LocationsColumn = ({ ticket }) => {
  const pickupCityUppercase = ticket.order_data.pickup.city.toUpperCase();
  const dropoffCityUppercase = ticket.order_data.dropoff.city.toUpperCase();

  return (
    <BodyColumn
      backgroundColor={'#FFFFFF'}
      width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.LOCATIONS}
    >
      <Row>
        <InnerColumn width={'50%'}>
          <CustomBlackText>{pickupCityUppercase}</CustomBlackText>
          <CustomRegularText>
            {ticket.order_data.pickup.country} - {ticket.order_data.pickup.zipcode}
          </CustomRegularText>
          <RegularText>
            {getFormatedDate(ticket.order_data.pickup.date)}{' '}
            {getFormatedTime(ticket.order_data.pickup.time_from)} -{' '}
            {getFormatedTime(ticket.order_data.pickup.time_to)}
          </RegularText>
        </InnerColumn>
        <InnerColumn width={'50%'}>
          <CustomBlackText>{dropoffCityUppercase}</CustomBlackText>
          <CustomRegularText>
            {ticket.order_data.dropoff.country} - {ticket.order_data.dropoff.zipcode}
          </CustomRegularText>
          <RegularText>
            {getFormatedDate(ticket.order_data.dropoff.date)}{' '}
            {getFormatedTime(ticket.order_data.dropoff.time_from)} -{' '}
            {getFormatedTime(ticket.order_data.dropoff.time_to)}
          </RegularText>
        </InnerColumn>
      </Row>
    </BodyColumn>
  );
};
